export const ACTION_TYPES = {
    GET_AUTH_USER_INFO: 'general/GET_AUTH_USER_INFO',
    GET_AUTH_USER_INFO_SUCCESS: 'general/GET_AUTH_USER_INFO_SUCCESS',
    GET_AUTH_USER_INFO_FAILED: 'general/GET_AUTH_USER_INFO_FAILED'
};
